import i18n from "i18next";
import { reactI18nextModule } from "react-i18next";

const resources = {
  en: {
    translation: {
      "patient.status.draft": "Draft",
      "patient.status.submitted": "In Progress",
      "patient.status.in_progress": "In Progress",
      "patient.status.payment_due": "Due Payment",
      "patient.status.awaiting_shipment": "Awaiting Shipment",
      "patient.status.in_transit": "In Transit",
      "patient.status.received": "Received",
      "patient.status.cancelled": "Cancelled",

      "patient.button.draft": "Continue",
      "patient.button.submitted": "View",
      "patient.button.in_progress": "View",
      "patient.button.payment_due": "Pay",
      "patient.button.awaiting_shipment": "View",
      "patient.button.in_transit": "View",
      "patient.button.received": "View",
      "patient.button.cancelled": "View",

      "manager.status.draft": "Draft",
      "manager.status.submitted": "Submitted",
      "manager.status.in_progress": "In Progress",
      "manager.status.payment_due": "Due Payment",
      "manager.status.awaiting_shipment": "Awaiting Shipment",
      "manager.status.in_transit": "In Transit",
      "manager.status.received": "Received",
      "manager.status.cancelled": "Cancelled",

      "manager.button.draft": "Continue",
      "manager.button.submitted": "Process",
      "manager.button.in_progress": "Continue",
      "manager.button.payment_due": "Continue",
      "manager.button.awaiting_shipment": "Continue",
      "manager.button.in_transit": "Continue",
      "manager.button.received": "View",
      "manager.button.cancelled": "View"
    }
  }
};

i18n
  .use(reactI18nextModule) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en",
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;


// WEBPACK FOOTER //
// ./src/utilities/i18n.js